<script>
export default {
  props: {
    merchant: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      defaultBanner: require('@assets/images/activity_default.png'),
      defaultLogo: require('@assets/images/logo_default.png'),
    }
  },
  computed: {
    isShowPrepaid() {
      return this.merchant.showPrepaid
    },
  }
}
</script>
<template>
  <div class="booking-section is-banner">
    <div class="subsection__banner">
      <picture class="booking-banner">
        <BaseImage :src="merchant.image" :error-src="defaultBanner" class-name="is-cover" />
      </picture>
    </div>
    <div class="subsection__menu">
      <div class="subsection__menu-left">
        <router-link :to="{ name: 'booking', query: { language: $route.query.language } }">
          <picture class="subsection__avatar">
            <BaseImage :src="merchant.logo" :error-src="defaultLogo" class-name="is-cover" />
          </picture>
          <div class="subsection__name">{{ merchant.name }}</div>
        </router-link>
      </div>
      <div class="subsection__menu-right">
        <div class="menus is-left">
          <router-link
            :to="{ name: 'booking', query: { language: $route.query.language } }"
            :class="{ 'router-link-exact-active': $route.name === 'booking-product' || $route.name === 'booking' }"
            class="button is-menu-style"
          >{{ $t('global.MERCHANT_OVERVIEW'/*總覽*/) }}</router-link>
          <router-link
            :to="{ name: 'booking-summary', query: { language: $route.query.language } }"
            :class="{ 'router-link-exact-active': $route.name === 'booking-summary' }"
            class="button is-menu-style"
          >{{ $t('global.MERCHANT_ABOUT'/*關於*/) }}</router-link>
          <router-link
            v-if="isShowPrepaid"
            :to="{ name: 'booking-prepaid-list', query: { language: $route.query.language } }"
            :class="{ 'router-link-exact-active': $route.name === 'booking-prepaid-list' || $route.name ===
          'booking-prepaid-item' }"
            class="button is-menu-style"
          >{{ $t('global.PAIPAID'/*方案*/) }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
